/**
 * Labstep
 *
 * @module components/Folder/Item
 * @desc Folder label
 */

import { EntityActionRemove } from 'labstep-web/components/Entity/Action/Remove';
import type React from 'react';
import { Label } from 'semantic-ui-react';
import styles from './styles.module.scss';
import type { FolderItemProps } from './types';

export const FolderItem: React.FC<FolderItemProps> = ({
  folder,
  parentEntity,
}) => (
  <Label size="large" circular className={styles.folderItem}>
    <span className={styles.folderName}>{folder.folder_path}</span>
    <span className={styles.removeAction}>
      <EntityActionRemove
        noConfirmation
        entity={null}
        entityId={[folder.id, folder.guid]}
        entityName={folder.entityName}
        parentName={parentEntity.entityName}
        parentId={parentEntity.id}
        actionComponentProps={{ type: 'icon', icon: 'times' }}
      />
    </span>
  </Label>
);
